module.exports = __webpack_public_path__ + "img/companyLogo.f063095e.svg";